<template>
  <div class="flow-path">
    <div class="container">
      <!-- 头部 -->
      <div class="header">
        <div class="header-title">严控流程</div>
        <p>严密的过程管控是项目按时、按质量提交的前提</p>
      </div>
      <div class="develop-step">
        <div class="step-item">
          <img src="../../assets/imgs/catchword-01.png" class="icon" alt="">
          <div class="title">客户咨询</div>
          <div class="step-line"></div>
          <ul class="step-main">
            <li>客户档案创立</li>
            <li>了解基本需求</li>
            <li>客户资源分配</li>
            <li>客服定期回访</li>
          </ul>
        </div>
        <div class="step-item">
          <img src="../../assets/imgs/flowpath-icon01.png" class="icon" alt="">
          <div class="title">启动阶段</div>
          <div class="step-line"></div>
          <ul class="step-main">
            <li>风险预判</li>
            <li>框定服务范围</li>
            <li>确定时间计划</li>
            <li>确定人员安排</li>
            <li>确定反馈机制</li>
            <li>定义成果标准</li>
            <li>发布实施成本</li>
          </ul>
        </div>
        <div class="step-item">
          <img src="../../assets/imgs/flowpath-icon02.png" class="icon" alt="">
          <div class="title">定位重塑</div>
          <div class="step-line"></div>
          <ul class="step-main">
            <li>成立项目组</li>
            <li>用研阶段</li>
            <li>头脑风暴</li>
            <li>概念设计</li>
            <li>风险预案</li>
            <li>场景模拟</li>
            <li>原型设计</li>
            <li>交砸策划</li>
            <li>原型评审</li>
          </ul>
        </div>
        <div class="step-item">
          <img src="../../assets/imgs/flowpath-icon03.png" class="icon" alt="">
          <div class="title">产品视觉</div>
          <div class="step-line"></div>
          <ul class="step-main">
            <li>理念创意</li>
            <li>交互改进</li>
            <li>风格设计</li>
            <li>在线评审</li>
            <li>批量设计</li>
          </ul>
        </div>
        <div class="step-item">
          <img src="../../assets/imgs/flowpath-icon04.png" class="icon" alt="">
          <div class="title">系统开发</div>
          <div class="step-line"></div>
          <ul class="step-main">
            <li>前端开发</li>
            <li>功能分解</li>
            <li>浏览器兼容测试</li>
            <li>数据库设计</li>
            <li>后台逻辑梳理</li>
            <li>编码阶段</li>
          </ul>
        </div>
        <div class="step-item">
          <img src="../../assets/imgs/flowpath-icon05.png" class="icon" alt="">
          <div class="title">测试修改</div>
          <div class="step-line"></div>
          <ul class="step-main">
            <li>BUG修改</li>
            <li>性能测试</li>
            <li>用户体验测试</li>
            <li>安全测试</li>
            <li>项目评审</li>
            <li>项目总结</li>
          </ul>
        </div>
        <div class="step-item">
          <img src="../../assets/imgs/flowpath-icon06.png" class="icon" alt="">
          <div class="title">上线运营</div>
          <div class="step-line"></div>
          <ul class="step-main">
            <li>上线准备</li>
            <li>功能培训</li>
            <li>数据监控</li>
            <li>日常推广</li>
            <li>定期回访</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.flow-path {
  width: 100%;
  height: 1039px;
  background: url("../../assets/imgs/flowpath-bg.png") no-repeat;
  background-size: 100% 100%;
}
.header {
  text-align: center;
  overflow: hidden;
  .header-title {
    font-size: 36px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    color: #ffffff;
    margin: 80px 0 24px;
  }
  p {
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #c8d8f3;
  }
}
.develop-step {
  width: 100%;
  margin-top: 80px;
  display: flex;
  justify-content: space-between;
  .step-item {
    width: 14.285%;
    position: relative;
    img {
      width: 77px;
      height: 85px;
    }
    .step-line {
      background: url(../../assets/imgs/step-arrow.png) no-repeat;
      background-size: 100% 100%;
      width: 26px;
      height: 22px;
      margin: 40px auto 50px;
    }
    .step-main {
      li {
        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: rgba(200, 216, 243, 0.7);
        line-height: 48px;
      }
    }
  }
  .step-item::before {
    width: 200px;
    position: absolute;
    content: "";
    top: 206px;
    left: 0px;
    height: 2px;
    background: #424d63;
    opacity: 0.5;
  }
  .title {
    font-size: 24px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #c8d8f3;
    margin-top: 35px;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1200px;
    padding: 0;
  }
}
</style>
